//Stateler çekilip return edilecek

export const ticketList = (state) => {
  return state.tickets
}

export const ticket = (state) => {
  return state.ticket
}

export const getTicketPageInfo = (state) => {
  return state.ticketPageInfo
}

export const getCommentPageInfo = (state) => {
  return state.commentPageInfo
}

export const getTicketComments = (state) => {
  return state.ticketComments
}

export const getTicketLoading = (state) => {
  return state.loading
}

export const getTicketStatus = (state) => {
  return state.ticketStatus
}

export const customerProducts = (state) => {
  return state.customerProducts
}



// WEBPACK FOOTER //
// ./src/store/modules/Ticket/Getters.js